// Datos de los slides del carrusel principal.
// Para agregar un nuevo slide basta con añadir un objeto al array.
// Campos:
// - className:    clase CSS específica del banner (banner-1, banner-2, ...)
// - title:        título principal (se muestra dentro de <strong>)
// - subtitle:     (opcional) subtítulo que aparece bajo el título principal
// - description:  texto descriptivo bajo el título
// - image:        nombre del archivo dentro de src/assets/img/
// - imageAlt:     texto alternativo para la imagen
// - link:         URL de destino del botón
// - buttonPrefix: texto del botón antes del <strong> (ej: "Ver")
// - buttonStrong: texto en negrita del botón (ej: "Curso", "Diplomado")

export const carruselSlides = [
  {
    className: 'banner-radiografia',
    title: '¡Tu opinión define el futuro minero!',
    subtitle: 'V Radiografía de la Capacitación Online en Minería',
    description:
      'Ayúdanos a mapear el presente y futuro de nuestra industria y estarás participando del sorteo de nuestro Diplomado de Planificación Minera Subterránea + unos AirPods.',
    image: 'BannerRadiografia.png',
    imageAlt: 'V Radiografía de la Minería 2026',
    link: 'https://radiografia.mine-class.com/?utm_source=direct&utm_medium=banner&utm_campaign=radiografia_capacitacion_minera&utm_id=526',
    buttonPrefix: '',
    buttonStrong: 'Participa'
  },
  {
    className: 'banner-1',
    title: 'Diplomado en Planificación Minera a Tajo Abierto:',
    description:
      'Especialízate en diseño, planificación y optimización de operaciones a cielo abierto bajo estándares reales de la industria.',
    image: 'RajoAbierto.jpg',
    imageAlt: 'Imagen banner 1',
    link: 'https://cursos.mine-class.com/aprende/200/diplomado-de-planificacion-minera-cielo-abierto?utm_source=banner_web',
    buttonPrefix: 'Ver',
    buttonStrong: 'Diplomado'
  },
  {
    className: 'banner-2',
    title: 'Curso Administración de Contratos:',
    description:
      'Gestiona contratos mineros con enfoque legal, financiero y operativo.',
    image: 'AdmContratos.jpg',
    imageAlt: 'Imagen banner 2',
    link: 'https://cursos.mine-class.com/aprende/193/administracion-de-contratos?utm_source=banner_web',
    buttonPrefix: 'Ver',
    buttonStrong: 'Curso'
  },
  {
    className: 'banner-3',
    title: 'Domina Excel Profesional:',
    description:
      'Funciones avanzadas, análisis y herramientas para entornos corporativos.',
    image: 'ExcelProf.jpg',
    imageAlt: 'Imagen banner 3',
    link: 'https://cursos.mine-class.com/aprende/205/excel-avanzado?utm_source=banner_web',
    buttonPrefix: 'Ver',
    buttonStrong: 'Curso'
  }
]

export default carruselSlides
